import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants/colors.constants';

export const labelStyle: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	mb: '2px',

	fontFamily: 'Montserrat, sans-serif',
	fontSize: 15,
	fontWeight: 600,
	lineHeight: 1.4,
	color: Colors.white,

	'&.Mui-focused': {
		color: Colors.white,
	},

	'&.Mui-error': {
		color: Colors.white,
	},

	'&.Mui-disabled': {
		color: Colors['white_a50'],
	},
};
